// clarity.service.ts
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

declare global {
  interface Window {
    clarity: any;
  }
}

@Injectable({ providedIn: 'root' })
export class ClarityService {
  private clarityProjectId = 'rxotlboodg';
  private initialized = false;

  init(): void {
    if (this.initialized) return;
    if (environment.production === false) return;
    this.initialized = true;

    // Dynamically load the Clarity script
    (function (c: any, l: any, a: any, r: any, i: any, t: any, y: any) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = true;
      t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(
      window,
      document,
      'clarity',
      'script',
      this.clarityProjectId,
      undefined,
      undefined
    );
  }

  identifyUser(userId: string): void {
    if (window.clarity && typeof window.clarity === 'function') {
      window.clarity('identify', userId);
    }
  }

  logCustomEvent(eventName: string, data?: Record<string, any>): void {
    if (window.clarity && typeof window.clarity === 'function') {
      window.clarity('event', eventName, data);
    }
  }
}
